import React from 'react'
import {withStyles} from 'material-ui/styles'
import withWidth from 'material-ui/utils/withWidth'
import compose from 'recompose/compose'
import {connect} from 'react-redux'

import styles from '../styles'
import Community from '../components/Community'
import actions from '../actions/community'
import headerActions from '../../header/actions/header'
import {push} from 'react-router-redux'
import PropTypes from 'prop-types'

class CommunityContainer extends React.Component {

  constructor(props) {
    super(props)

    props.initialSearch()
  }

  render() {
    return <Community {...this.props}/>
  }
}

CommunityContainer.propTypes = {
  initialSearch: PropTypes.func.isRequired,
}

const mapStateToProps = state => {
  const data = state.ui.community.community
  return {
    items: data.get('items').toArray(),
    error: data.get('error'),
    offset: data.get('offset'),
    limit: data.get('limit'),
    isSearching: data.get('isSearching'),
    expectMore: data.get('expectMore'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    initialSearch: () => dispatch(headerActions.initialSearch()),
    search: () => dispatch(headerActions.searchMore()),
    goTo: url => dispatch(push(url)),
    setOffset: offset => dispatch(actions.setOffset(offset)),
    setLimit: limit => dispatch(actions.setLimit(limit)),
  }
}

const Container = connect(mapStateToProps, mapDispatchToProps)(CommunityContainer)
const Styled = compose(withStyles(styles, {withTheme: true}), withWidth())(Container)

export default Styled



// WEBPACK FOOTER //
// ./src/sections/community/containers/community.js